<template>
	<div>
		<progres-rombel v-if="isPengelolaOrStaf || isWaliKelasOrGuruBK" />
		<progres-siswa-view v-if="isSiswa" />
	</div>
</template>

<script>
import ProgresRombel from "@/components/ProgresRombel.vue";
import ProgresSiswaView from "./ProgresSiswaView.vue";

export default {
	name: "HomeView",
	data() {
		return {};
	},
	components: {
		ProgresRombel,
		ProgresSiswaView,
	},
	computed: {
		user() {
			return this.$store.getters.getUser;
		},
		isPengelolaOrStaf() {
			const roles = this.$store.getters.getRoles;
			return roles?.some((r) => ["dev", "superadmin", "admin-kesiswaan", "admin-buku-induk", "pengelola", "staf"].includes(r.role));
		},
		isWaliKelasOrGuruBK() {
			const roles = this.$store.getters.getRoles;
			return this.user.type === "guru" && roles?.some((r) => ["wali-kelas", "guru-bk"].includes(r.role));
		},
		isSiswa() {
			return this.user.type === "siswa";
		},
	},
	watch: {},
	mounted() {},
	beforeUnmount() {},
	methods: {},
};
</script>
